var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.renderCount, attrs: { id: "archive" } },
    [
      _c(
        "AppBreadCrumb",
        {
          attrs: {
            paths: [{ title: _vm.$t("message.archive") }],
            select: true,
            "show-subjects": true,
          },
        },
        [
          _c("div", { staticClass: "time-select-section" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.timeSelect,
                    expression: "timeSelect",
                  },
                ],
                staticClass: "time-select-dropdown",
                attrs: { id: "time-select" },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.timeSelect = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              [
                _c("option", { attrs: { value: "today" } }, [
                  _vm._v(_vm._s(_vm.$t("time.today"))),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "yesterday" } }, [
                  _vm._v(_vm._s(_vm.$t("time.yesterday"))),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "current-week" } }, [
                  _vm._v(_vm._s(_vm.$t("time.currentWeek"))),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "last-week" } }, [
                  _vm._v(_vm._s(_vm.$t("time.lastWeek"))),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "current-month" } }, [
                  _vm._v(_vm._s(_vm.$t("time.currentMonth"))),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "last-month" } }, [
                  _vm._v(_vm._s(_vm.$t("time.lastMonth"))),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "last-30" } }, [
                  _vm._v(_vm._s(_vm.$t("time.last30Day"))),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "custom" } }, [
                  _vm._v(_vm._s(_vm.$t("time.custom"))),
                ]),
                _vm._v(" "),
                _vm._l(_vm.getLast11Months(), function (m, i) {
                  return _c("option", { key: i, domProps: { value: m.date } }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(m.name) +
                        "\n                "
                    ),
                  ])
                }),
              ],
              2
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "archive-toolbar" },
        [
          _c("ArchiveFilterBar", {
            attrs: {
              query: _vm.query,
              "start-date": _vm.startDate,
              "end-date": _vm.endDate,
              "selected-user": _vm.selectedUser,
              "selected-site": _vm.selectedSite,
              "multi-select-value": _vm.multiSelectValue,
              "destroyer-multi-select-value": _vm.destroyerMultiSelectValue,
              "starter-multi-select-value": _vm.starterMultiSelectValue,
              "tags-multi-select-value": _vm.tagsMultiSelectValue,
              point: _vm.point,
              "filter-description": _vm.filterDescription,
              "filter-video-call": _vm.filterVideoCall,
              "filter-lost-chats": _vm.filterLostChats,
              "filter-closed-by-agent": _vm.filterClosedByAgent,
              "time-select": _vm.timeSelect,
              "users-filter": _vm.usersFilter.data || [],
            },
            on: {
              change: _vm.handleFiltersChange,
              "reset-filters": _vm.resetFilters,
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "search-section" }, [
            _c(
              "div",
              { staticClass: "search-bar" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.query,
                      expression: "query",
                    },
                  ],
                  staticClass: "search-input",
                  attrs: { type: "text", placeholder: _vm.$t("message.query") },
                  domProps: { value: _vm.query },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.query = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "a-tooltip",
                  {
                    attrs: {
                      placement: "top",
                      title:
                        "İsim, mail, not, tel no, kullanıcı bilgileri alanlarında arama yapar",
                    },
                  },
                  [_c("span", { staticClass: "exclamation" }, [_vm._v("!")])]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-container",
        { staticClass: "mt-3", attrs: { fluid: "" } },
        [
          _vm.selectedVisitorId
            ? _c(
                "b-row",
                { staticClass: "filterLabelWrapper" },
                [
                  _c("VisitorMiniFilterPreview", {
                    attrs: {
                      "default-open": false,
                      value: {
                        name: "visitorId",
                        value: _vm.selectedVisitorId,
                        rule: "is",
                      },
                      "on-finished": _vm.$_.noop,
                      "on-removed": _vm.removeSelectedVisitorIDFilter,
                      icon: "filter_alt",
                      "read-only": true,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "custom-row" },
            [
              _c(
                "b-col",
                {
                  class: {
                    "col-lg-5": !_vm.wideScreen,
                    "col-lg-4": _vm.wideScreen,
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "scrollable",
                      attrs: { "scroll-top": "0", id: "conversation-list" },
                    },
                    [
                      !_vm.visitors.data.length &&
                      !_vm.isBusy &&
                      !_vm.spinnerShow
                        ? _c("EmptyFilterResult", {
                            attrs: { "clear-filters": _vm.resetFilters },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "div",
                          { staticClass: "pagination-toolbar" },
                          [
                            _c(
                              "a-button",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: { placement: "bottom" },
                                    expression: "{ placement: 'bottom' }",
                                  },
                                ],
                                staticClass:
                                  "actionButton d-flex align-items-center classic-button",
                                staticStyle: {
                                  "margin-right": "auto !important",
                                },
                                attrs: {
                                  size: "small",
                                  content: _vm.$t(
                                    "message.clearSelectedFiltersTooltip"
                                  ),
                                },
                                on: { click: _vm.resetFilters },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-right": "3px",
                                      display: "block",
                                      "font-size": "12px",
                                      overflow: "hidden",
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "md-icon" }, [
                                      _vm._v("delete_forever"),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "actions" },
                              [
                                _c(
                                  "a",
                                  {
                                    staticStyle: { "margin-right": "10px" },
                                    on: { click: _vm.decreaseAll },
                                  },
                                  [_vm._v("<<")]
                                ),
                                _vm._v(" "),
                                _c("a", { on: { click: _vm.decrease } }, [
                                  _vm._v("<"),
                                ]),
                                _vm._v(" "),
                                _c("a-input", {
                                  staticStyle: {
                                    width: "60px",
                                    border: "none",
                                  },
                                  attrs: { type: "number" },
                                  model: {
                                    value: _vm.currentPage,
                                    callback: function ($$v) {
                                      _vm.currentPage = $$v
                                    },
                                    expression: "currentPage",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      padding: "2px",
                                      "font-size": "15px",
                                    },
                                  },
                                  [_vm._v("/")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      width: "auto",
                                      margin: "0 6px",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.visitors.pageCount))]
                                ),
                                _vm._v(" "),
                                _c("a", { on: { click: _vm.increase } }, [
                                  _vm._v(">"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticStyle: { "margin-left": "10px" },
                                    on: { click: _vm.increaseAll },
                                  },
                                  [_vm._v(">>")]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "a-popover",
                              {
                                attrs: {
                                  placement: "bottom",
                                  overlayClassName: "btnPerPagePopover",
                                  visible: _vm.pageSizeChangerVisible,
                                },
                                on: {
                                  visibleChange: function ($event) {
                                    _vm.pageSizeChangerVisible =
                                      !_vm.pageSizeChangerVisible
                                  },
                                },
                              },
                              [
                                _c("template", { slot: "content" }, [
                                  _c(
                                    "div",
                                    { staticClass: "page-options" },
                                    _vm._l(
                                      [
                                        5, 10, 20, 30, 50, 75, 100, 150, 200,
                                        250, 300,
                                      ],
                                      function (val, i) {
                                        return _c(
                                          "div",
                                          {
                                            key: i,
                                            staticClass: "item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.changePerPage(val)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "value" },
                                              [_vm._v(_vm._s(val))]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a-button",
                                  {
                                    staticClass: "btnPerPage",
                                    on: {
                                      click: function ($event) {
                                        _vm.pageSizeChangerVisible = true
                                      },
                                    },
                                  },
                                  [
                                    _c("SortIcon"),
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$t("message.perPageInFilter")
                                        ) +
                                        ": " +
                                        _vm._s(_vm.pagination.limit) +
                                        "\n                                    "
                                    ),
                                    _c("a-icon", {
                                      attrs: { type: "caret-down" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      !_vm.isBusy && !_vm.spinnerShow
                        ? _c("div", [
                            _vm.visitors.data.length > 0
                              ? _c(
                                  "div",
                                  [
                                    !_vm.isScrolling
                                      ? _c(
                                          "b-table",
                                          {
                                            attrs: {
                                              id: "visitor-list-table",
                                              items: _vm.visitors.data.slice(
                                                0,
                                                _vm.perPage
                                              ),
                                              fields: _vm.fields,
                                              "tbody-tr-class": _vm.rowClass,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "cell(actions)",
                                                  fn: function (data, item) {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          key: data.item._id,
                                                          staticClass: "info",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.view(
                                                                data.item._id
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "custom-card userInfo",
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.maskContactFullname(
                                                                      data.item
                                                                        .fullname ||
                                                                        "-",
                                                                      data.item
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("b", [
                                                                _vm._v(
                                                                  "\n                                                " +
                                                                    _vm._s(
                                                                      _vm.getEmail(
                                                                        data.item
                                                                      )
                                                                    ) +
                                                                    "\n                                            "
                                                                ),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("b", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    (data.item
                                                                      .users
                                                                      .length >
                                                                    0
                                                                      ? data.item.users.slice(
                                                                          0,
                                                                          3
                                                                        )
                                                                      : [
                                                                          data
                                                                            .item
                                                                            .connectedUser,
                                                                        ]
                                                                    )
                                                                      .map(
                                                                        function (
                                                                          x
                                                                        ) {
                                                                          return _vm.getUserHelper(
                                                                            x
                                                                          )
                                                                        }
                                                                      )
                                                                      .join(
                                                                        ", "
                                                                      )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "custom-card back chatMeta",
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "date"
                                                                    )(
                                                                      data.item
                                                                        .createdDate,
                                                                      "D/M/YY HH:m:s"
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b",
                                                                [
                                                                  _c(
                                                                    "PassedTimeCounterTimeFormat",
                                                                    {
                                                                      attrs: {
                                                                        id: data
                                                                          .item
                                                                          ._id,
                                                                        date:
                                                                          data
                                                                            .item
                                                                            .connectedDate ||
                                                                          data
                                                                            .item
                                                                            .createdDate,
                                                                        endDate:
                                                                          data
                                                                            .item
                                                                            .destroyedDate,
                                                                        shortFormat: true,
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b",
                                                                [
                                                                  _c("a-rate", {
                                                                    style: {
                                                                      color:
                                                                        data
                                                                          .item
                                                                          .description
                                                                          ? "orangered"
                                                                          : "#fadb14",
                                                                    },
                                                                    attrs: {
                                                                      "default-value":
                                                                        data
                                                                          .item
                                                                          .point ||
                                                                        0,
                                                                      disabled:
                                                                        "",
                                                                      size: "12",
                                                                    },
                                                                  }),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              2599730353
                                            ),
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-center text-danger my-2",
                                                attrs: { slot: "table-busy" },
                                                slot: "table-busy",
                                              },
                                              [
                                                _c("b-spinner", {
                                                  staticClass: "align-middle",
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-center text-info my-3",
                                          },
                                          [
                                            _c(
                                              "b-table",
                                              {
                                                attrs: {
                                                  id: "visitor-list-tables",
                                                  fields: _vm.fields,
                                                  items: _vm.visitors.data,
                                                  "tbody-tr-class":
                                                    _vm.rowClass,
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "cell(actions)",
                                                      fn: function (
                                                        data,
                                                        item
                                                      ) {
                                                        return [
                                                          _c(
                                                            "div",
                                                            {
                                                              key: data.item
                                                                ._id,
                                                              staticClass:
                                                                "info",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.view(
                                                                      data.item
                                                                        ._id
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "custom-card userInfo",
                                                                },
                                                                [
                                                                  _c("b", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        data
                                                                          .item
                                                                          .fullname ||
                                                                          "-"
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("b", [
                                                                    _vm._v(
                                                                      "\n                                                    " +
                                                                        _vm._s(
                                                                          _vm.getEmail(
                                                                            data.item
                                                                          )
                                                                        ) +
                                                                        "\n                                                "
                                                                    ),
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("b", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        (data
                                                                          .item
                                                                          .users
                                                                          .length >
                                                                        0
                                                                          ? data.item.users.slice(
                                                                              0,
                                                                              3
                                                                            )
                                                                          : [
                                                                              data
                                                                                .item
                                                                                .connectedUser,
                                                                            ]
                                                                        )
                                                                          .map(
                                                                            function (
                                                                              x
                                                                            ) {
                                                                              return _vm.getUserHelper(
                                                                                x
                                                                              )
                                                                            }
                                                                          )
                                                                          .join(
                                                                            ", "
                                                                          )
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "custom-card back chatMeta",
                                                                },
                                                                [
                                                                  _c("b", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "date"
                                                                        )(
                                                                          data
                                                                            .item
                                                                            .createdDate,
                                                                          "D/M/YY HH:m:s"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "b",
                                                                    [
                                                                      _c(
                                                                        "PassedTimeCounterTimeFormat",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              id: data
                                                                                .item
                                                                                ._id,
                                                                              date:
                                                                                data
                                                                                  .item
                                                                                  .connectedDate ||
                                                                                data
                                                                                  .item
                                                                                  .createdDate,
                                                                              endDate:
                                                                                data
                                                                                  .item
                                                                                  .destroyedDate,
                                                                              shortFormat: true,
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "b",
                                                                    [
                                                                      _c(
                                                                        "a-rate",
                                                                        {
                                                                          style:
                                                                            {
                                                                              color:
                                                                                data
                                                                                  .item
                                                                                  .description
                                                                                  ? "orangered"
                                                                                  : "#fadb14",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              "default-value":
                                                                                data
                                                                                  .item
                                                                                  .point ||
                                                                                0,
                                                                              disabled:
                                                                                "",
                                                                              size: "12",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  3508913591
                                                ),
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-center text-danger my-2",
                                                    attrs: {
                                                      slot: "table-busy",
                                                    },
                                                    slot: "table-busy",
                                                  },
                                                  [
                                                    _c("b-spinner", {
                                                      staticClass:
                                                        "align-middle",
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "ul",
                                              {
                                                staticClass: "archive-skeleton",
                                              },
                                              _vm._l(3, function (v, i) {
                                                return _c(
                                                  "li",
                                                  {
                                                    key: i,
                                                    staticClass: "pb-3",
                                                    staticStyle: {
                                                      "list-style": "none",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "info row",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col custom-card userInfo",
                                                          },
                                                          [
                                                            _c("a-skeleton", {
                                                              attrs: {
                                                                active: "",
                                                                paragraph: {
                                                                  rows: 2,
                                                                },
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col custom-card back chatMeta",
                                                          },
                                                          [
                                                            _c("a-skeleton", {
                                                              staticClass:
                                                                "row",
                                                              staticStyle: {
                                                                "padding-left":
                                                                  "15px !important",
                                                              },
                                                              attrs: {
                                                                active: "",
                                                                paragraph: {
                                                                  rows: 1,
                                                                },
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "b",
                                                              {
                                                                staticStyle: {
                                                                  display:
                                                                    "block",
                                                                  "text-align":
                                                                    "start",
                                                                  "margin-top":
                                                                    "13px",
                                                                },
                                                              },
                                                              [
                                                                _c("a-rate", {
                                                                  staticClass:
                                                                    "row",
                                                                  staticStyle: {
                                                                    color:
                                                                      "#fadb14",
                                                                  },
                                                                  attrs: {
                                                                    "default-value": 5,
                                                                    disabled:
                                                                      "",
                                                                    size: "12",
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }),
                                              0
                                            ),
                                          ],
                                          1
                                        ),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  { staticClass: "text-center text-info my-3" },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$t("message.chatNotFound")) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !!_vm.isBusy && !_vm.spinnerShow
                        ? _c(
                            "div",
                            { staticClass: "text-center text-info my-3" },
                            [
                              !!_vm.lastRegisteredMessages.length
                                ? _c(
                                    "div",
                                    [
                                      !_vm.isScrolling
                                        ? _c(
                                            "b-table",
                                            {
                                              attrs: {
                                                id: "visitor-list-table",
                                                fields: _vm.fields,
                                                items:
                                                  _vm.lastRegisteredMessages,
                                                "tbody-tr-class": _vm.rowClass,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "cell(actions)",
                                                    fn: function (data, item) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            key: data.item._id,
                                                            staticClass: "info",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.view(
                                                                  data.item._id
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "custom-card userInfo",
                                                              },
                                                              [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.item
                                                                        .fullname ||
                                                                        "-"
                                                                    )
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("b", [
                                                                  _vm._v(
                                                                    "\n                                                " +
                                                                      _vm._s(
                                                                        _vm.getEmail(
                                                                          data.item
                                                                        )
                                                                      ) +
                                                                      "\n                                            "
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      (data.item
                                                                        .users
                                                                        .length >
                                                                      0
                                                                        ? data.item.users.slice(
                                                                            0,
                                                                            3
                                                                          )
                                                                        : [
                                                                            data
                                                                              .item
                                                                              .connectedUser,
                                                                          ]
                                                                      )
                                                                        .map(
                                                                          function (
                                                                            x
                                                                          ) {
                                                                            return _vm.getUserHelper(
                                                                              x
                                                                            )
                                                                          }
                                                                        )
                                                                        .join(
                                                                          ", "
                                                                        )
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "custom-card back chatMeta",
                                                              },
                                                              [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "date"
                                                                      )(
                                                                        data
                                                                          .item
                                                                          .createdDate,
                                                                        "D/M/YY HH:m:s"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "b",
                                                                  [
                                                                    _c(
                                                                      "PassedTimeCounterTimeFormat",
                                                                      {
                                                                        attrs: {
                                                                          id: data
                                                                            .item
                                                                            ._id,
                                                                          date:
                                                                            data
                                                                              .item
                                                                              .connectedDate ||
                                                                            data
                                                                              .item
                                                                              .createdDate,
                                                                          endDate:
                                                                            data
                                                                              .item
                                                                              .destroyedDate,
                                                                          shortFormat: true,
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "b",
                                                                  [
                                                                    _c(
                                                                      "a-rate",
                                                                      {
                                                                        style: {
                                                                          color:
                                                                            data
                                                                              .item
                                                                              .description
                                                                              ? "orangered"
                                                                              : "#fadb14",
                                                                        },
                                                                        attrs: {
                                                                          "default-value":
                                                                            data
                                                                              .item
                                                                              .point ||
                                                                            0,
                                                                          disabled:
                                                                            "",
                                                                          size: "12",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                2416333239
                                              ),
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-center text-danger my-2",
                                                  attrs: { slot: "table-busy" },
                                                  slot: "table-busy",
                                                },
                                                [
                                                  _c("b-spinner", {
                                                    staticClass: "align-middle",
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "archive-skeleton" },
                                _vm._l(_vm.skeletonCount, function (v, i) {
                                  return _c(
                                    "li",
                                    {
                                      key: i,
                                      staticClass: "pb-3",
                                      staticStyle: { "list-style": "none" },
                                    },
                                    [
                                      _c("div", { staticClass: "info row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col custom-card userInfo",
                                          },
                                          [
                                            _c("a-skeleton", {
                                              attrs: {
                                                active: "",
                                                paragraph: { rows: 2 },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col custom-card back chatMeta",
                                          },
                                          [
                                            _c("a-skeleton", {
                                              staticClass: "row",
                                              staticStyle: {
                                                "padding-left":
                                                  "15px !important",
                                              },
                                              attrs: {
                                                active: "",
                                                paragraph: { rows: 1 },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "b",
                                              {
                                                staticStyle: {
                                                  display: "block",
                                                  "text-align": "start",
                                                  "margin-top": "13px",
                                                },
                                              },
                                              [
                                                _c("a-rate", {
                                                  staticClass: "row",
                                                  staticStyle: {
                                                    color: "#fadb14",
                                                  },
                                                  attrs: {
                                                    "default-value": 5,
                                                    disabled: "",
                                                    size: "12",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.spinnerShow
                        ? [
                            _c("font-awesome-icon", {
                              attrs: { icon: "spinner", spin: "" },
                            }),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "pl-3",
                  class: {
                    "col-lg-7": !_vm.wideScreen,
                    "col-lg-5": _vm.wideScreen,
                  },
                },
                [
                  _c("div", { staticClass: "scrollable" }, [
                    _vm.selectedHistory.id && !_vm.wideScreen
                      ? _c(
                          "div",
                          { staticClass: "userMetaInfo bg-white" },
                          [
                            _c("b-col", { staticStyle: { margin: "10px" } }, [
                              _c("div", { staticClass: "userInfo" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("message.fullName")) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "tippy",
                                        rawName: "v-tippy",
                                        value: {
                                          followCursor: true,
                                          placement: "bottom-end",
                                          theme: _vm.isDarkMode
                                            ? "light-border"
                                            : "google",
                                        },
                                        expression:
                                          "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                        theme: isDarkMode ? 'light-border' : 'google',\n                                    }",
                                      },
                                    ],
                                    staticClass: "userInfo sec",
                                    attrs: {
                                      content: _vm.maskContactFullname(
                                        _vm.selectedHistory.conversation
                                          .fullname,
                                        _vm.selectedHistory.conversation
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.maskContactFullname(
                                            _vm.selectedHistory.conversation
                                              .fullname,
                                            _vm.selectedHistory.conversation
                                          )
                                        ) +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("message.email")) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "tippy",
                                        rawName: "v-tippy",
                                        value: {
                                          followCursor: true,
                                          placement: "bottom-end",
                                          theme: _vm.isDarkMode
                                            ? "light-border"
                                            : "google",
                                        },
                                        expression:
                                          "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                        theme: isDarkMode ? 'light-border' : 'google',\n                                    }",
                                      },
                                    ],
                                    staticClass: "userInfo sec",
                                    attrs: {
                                      content: _vm.maskContactInfo(
                                        "email",
                                        _vm.selectedHistory.conversation.email,
                                        5
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.maskContactInfo(
                                            "email",
                                            _vm.selectedHistory.conversation
                                              .email,
                                            5
                                          )
                                        ) +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("message.department")) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("message.representative")) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo sec" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        (_vm.selectedHistory.conversation.users
                                          .length > 0
                                          ? _vm.selectedHistory.conversation.users.slice(
                                              0,
                                              3
                                            )
                                          : [
                                              _vm.selectedHistory.conversation
                                                .connectedUser,
                                            ]
                                        )
                                          .map(function (x) {
                                            return _vm.getUserHelper(x)
                                          })
                                          .join(", ")
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "d-flex" }, [
                                _c("div", { staticClass: "userInfo" }, [
                                  _c("div", { staticClass: "userInfo first" }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.$t("message.country")) +
                                        "\n                                    "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "userInfo sec" }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.$_.get(
                                            _vm.selectedHistory,
                                            "conversation.visitor.country",
                                            "-"
                                          )
                                        ) +
                                        "\n                                    "
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo pl-3" }, [
                                  _c("div", { staticClass: "userInfo first" }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.$t("message.language")) +
                                        "\n                                    "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "userInfo sec" }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.selectedHistory.conversation
                                            .languageCode
                                        ) +
                                        "\n                                    "
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("message.osAndBrowser")) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo sec" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$_.get(
                                          _vm.selectedHistory,
                                          "conversation.visitor.os"
                                        )
                                      ) +
                                      "\n                                    " +
                                      _vm._s(
                                        _vm.$_.get(
                                          _vm.selectedHistory,
                                          "conversation.visitor.browser"
                                        )
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v("IP"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo sec" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$_.get(
                                          _vm.selectedHistory,
                                          "conversation.visitor.ipAddress"
                                        )
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("message.chatId")) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo sec" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.selectedHistory.conversation._id
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("message.visitorId")) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "userInfo sec" },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$_.get(
                                            _vm.selectedHistory,
                                            "conversation.visitor._id"
                                          )
                                        ) +
                                        "\n                                    "
                                    ),
                                    _vm.selectedHistory.conversation
                                      .startedWithChatBot
                                      ? _c(
                                          "md-button",
                                          {
                                            directives: [
                                              {
                                                name: "tippy",
                                                rawName: "v-tippy",
                                                value: {
                                                  followCursor: true,
                                                  placement: "bottom-end",
                                                  theme: _vm.isDarkMode
                                                    ? "light-border"
                                                    : "google",
                                                },
                                                expression:
                                                  "{\n                                            followCursor: true,\n                                            placement: 'bottom-end',\n                                            theme: isDarkMode ? 'light-border' : 'google',\n                                        }",
                                              },
                                            ],
                                            staticClass: "md-icon-button",
                                            attrs: {
                                              content: "Open In Chatbot",
                                            },
                                            on: { click: _vm.openInChatbot },
                                          },
                                          [
                                            _c("md-icon", [
                                              _vm._v("open_in_new"),
                                            ]),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "userInfo" }, [
                                _c("div", { staticClass: "userInfo first" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$t("message.customerClientVersion")
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "userInfo sec" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$_.get(
                                          _vm.selectedHistory,
                                          "conversation.visitor.version.versionStr",
                                          "-"
                                        )
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm.selectedHistory.conversation.description
                                ? _c("div", { staticClass: "userInfo" }, [
                                    _c(
                                      "div",
                                      { staticClass: "userInfo first" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$t("message.visitorFeedback")
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "userInfo sec",
                                        on: { click: _vm.showModal },
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            directives: [
                                              {
                                                name: "b-modal",
                                                rawName:
                                                  "v-b-modal.visitor-message",
                                                modifiers: {
                                                  "visitor-message": true,
                                                },
                                              },
                                            ],
                                            staticStyle: {
                                              "word-wrap": "break-word",
                                              overflow: "hidden",
                                              "text-overflow": "ellipsis",
                                              display: "-webkit-box",
                                              "-webkit-box-orient": "vertical",
                                              "-webkit-line-clamp": "3",
                                              "word-break": "break-all",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.selectedHistory
                                                    .conversation.description
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c("b-col", [
                                  _c(
                                    "h5",
                                    {
                                      staticClass:
                                        "text-center pointer text-info my-2",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(_vm.$t("message.userInfo")) +
                                          "\n                                    "
                                      ),
                                      _c(
                                        "md-icon",
                                        { staticClass: "text-info" },
                                        [_vm._v("expand_more")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isBusy || _vm.isLoading
                      ? _c("div", { attrs: { id: "message-skeleton" } }, [
                          _c(
                            "div",
                            {
                              staticClass: "row",
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column",
                                "align-items": "center",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "col-sm-4" },
                                [
                                  _c("a-skeleton", {
                                    attrs: {
                                      active: "",
                                      paragraph: { rows: 0 },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "row",
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-sm-4",
                                  staticStyle: { "margin-top": "-12%" },
                                },
                                [
                                  _c("a-skeleton", {
                                    attrs: {
                                      active: "",
                                      paragraph: { rows: 1 },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-sm-4",
                                  staticStyle: { "margin-top": "-8%" },
                                },
                                [
                                  _c("a-skeleton", {
                                    attrs: {
                                      active: "",
                                      paragraph: { rows: 2 },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "row",
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column",
                                "align-items": "center",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-sm-6",
                                  staticStyle: { "margin-top": "-15%" },
                                },
                                [
                                  _c("a-skeleton", {
                                    attrs: {
                                      active: "",
                                      paragraph: { rows: 0 },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "row",
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-sm-4",
                                  staticStyle: { "margin-top": "-12%" },
                                },
                                [
                                  _c("a-skeleton", {
                                    attrs: {
                                      active: "",
                                      paragraph: { rows: 2 },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-sm-4",
                                  staticStyle: { "margin-top": "-8%" },
                                },
                                [
                                  _c("a-skeleton", {
                                    attrs: {
                                      active: "",
                                      paragraph: { rows: 0 },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ])
                      : _c(
                          "div",
                          [
                            _vm.getMessages().length &&
                            _vm.selectedHistory.conversation._id !== null
                              ? _c("MessageList", {
                                  attrs: {
                                    "always-scroll-to-bottom": false,
                                    colors: _vm.colors,
                                    messages: _vm.getMessages(),
                                    participants: _vm.getParticipants(),
                                    "scroll-top": true,
                                    "channel-id":
                                      _vm.selectedHistory.conversation.channel,
                                    contextMenuVisable: false,
                                  },
                                })
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "bg-light border px-3 py-1 px-3 text-center",
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$t("message.noMessageInChat")
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                          ],
                          1
                        ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.isBusy || _vm.isLoading
                ? _c("b-col", { staticClass: "col-lg-3 bg-white scrollable" }, [
                    _c(
                      "ul",
                      { staticClass: "head-title" },
                      [
                        _c("a-skeleton", {
                          attrs: { active: "", paragraph: { rows: 0 } },
                        }),
                        _vm._v(" "),
                        _vm._l(11, function (v, i) {
                          return _c(
                            "li",
                            {
                              key: i,
                              staticClass: "user-info-container mx-3 px-3",
                              staticStyle: { "list-style": "none" },
                            },
                            [
                              _c("a-skeleton", {
                                attrs: { active: "", paragraph: { rows: 0 } },
                              }),
                            ],
                            1
                          )
                        }),
                      ],
                      2
                    ),
                  ])
                : _c(
                    "b-col",
                    {
                      staticClass: "archiveUserInfoWidget",
                      class: [
                        _vm.selectedHistory.id ? "" : "bg-white scrollable",
                      ],
                      style: !_vm.selectedHistory.id && { padding: "4px" },
                      attrs: {
                        id: [_vm.selectedHistory.id ? "" : "information-list2"],
                      },
                    },
                    [
                      _vm.selectedHistory.id
                        ? _c(
                            "div",
                            [
                              _c("div", { attrs: { id: "chatCard" } }, [
                                _c("div", { staticClass: "headtitle" }, [
                                  _c("span", { staticClass: "text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("userInfoWidget.userInformation")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "ml-4 btn-start-chat" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "classic-button",
                                          on: {
                                            click: function () {
                                              return this$1.$router.push(
                                                "/visitors/" +
                                                  _vm.selectedHistory
                                                    .conversation.visitor._id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.$t("message.userProfile")
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.isWABusiness()
                                        ? _c(
                                            "button",
                                            {
                                              staticClass: "userProfile",
                                              on: {
                                                click: _vm.startWhatsappChat,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    Start Chat\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isWhatsappV1()
                                        ? _c(
                                            "button",
                                            {
                                              staticClass: "userProfile",
                                              on: {
                                                click: _vm.startWhatsappChat,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    Start Chat\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isWhatsappV2()
                                        ? _c(
                                            "button",
                                            {
                                              staticClass: "userProfile",
                                              on: {
                                                click: _vm.startWhatsappChat,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    Start Chat\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isWhatsappV3()
                                        ? _c(
                                            "button",
                                            {
                                              staticClass: "userProfile",
                                              on: {
                                                click: _vm.startWhatsappChat,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    Start Chat\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isInstagram()
                                        ? _c(
                                            "button",
                                            {
                                              staticClass: "userProfile",
                                              on: {
                                                click: _vm.startInstagramChat,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    Start Chat\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isMessenger()
                                        ? _c(
                                            "button",
                                            {
                                              staticClass: "userProfile",
                                              on: {
                                                click: _vm.startMessengerChat,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    Start Chat\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isTelegram()
                                        ? _c(
                                            "button",
                                            {
                                              staticClass: "userProfile",
                                              on: {
                                                click: _vm.startTelegramChat,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    Start Chat\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isLinkedin()
                                        ? _c(
                                            "button",
                                            {
                                              staticClass: "userProfile",
                                              on: {
                                                click: _vm.startLinkedinChat,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    Start Chat\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "details-chat-card" },
                                  [
                                    _vm.getSubjectName(
                                      _vm.selectedHistory.conversation.subject
                                    )
                                      ? _c(
                                          "div",
                                          { staticClass: "user-detail" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "icon material-icons",
                                              },
                                              [_vm._v("sell")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex w-full centered space-between",
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.getSubjectName(
                                                          _vm.selectedHistory
                                                            .conversation
                                                            .subject
                                                        )
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass: "copyButton",
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.copyTextToClipboard(
                                                          _vm.getSubjectName(
                                                            _vm.selectedHistory
                                                              .conversation
                                                              .subject
                                                          ) || "N/A"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("a-icon", {
                                                      attrs: { type: "copy" },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "user-detail" }, [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                followCursor: true,
                                                placement: "bottom-end",
                                              },
                                              expression:
                                                "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                    }",
                                            },
                                          ],
                                          staticClass: "icon material-icons",
                                          attrs: {
                                            content: _vm.$t(
                                              "userInfoWidget.fullName"
                                            ),
                                          },
                                        },
                                        [_vm._v("person")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "input-value" },
                                        [
                                          _c("div", { staticClass: "w-full" }, [
                                            _c(
                                              "span",
                                              { attrs: { id: "fullName" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.maskContactFullname(
                                                      _vm.selectedHistory
                                                        .conversation.fullname,
                                                      _vm.selectedHistory
                                                        .conversation
                                                    ) || "N/A"
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "md-icon",
                                                staticStyle: {
                                                  color: "#ffa800",
                                                  cursor: "pointer",
                                                },
                                                on: { click: _vm.seeAll },
                                              },
                                              [_vm._v("zoom_in")]
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "copyButton",
                                                on: {
                                                  click: function ($event) {
                                                    _vm.copyTextToClipboard(
                                                      _vm.maskContactFullname(
                                                        _vm.selectedHistory
                                                          .conversation
                                                          .fullname,
                                                        _vm.selectedHistory
                                                          .conversation
                                                      ) || "N/A"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("a-icon", {
                                                  attrs: { type: "copy" },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "user-detail" }, [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                followCursor: true,
                                                placement: "bottom-end",
                                              },
                                              expression:
                                                "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                    }",
                                            },
                                          ],
                                          staticClass: "icon material-icons",
                                          attrs: {
                                            content: _vm.$t("coupon.email"),
                                          },
                                        },
                                        [_vm._v("mail")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "input-value" },
                                        [
                                          _c("div", { staticClass: "w-full" }, [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.maskContactInfo(
                                                    "email",
                                                    _vm.selectedHistory
                                                      .conversation.email,
                                                    5
                                                  ) || "N/A"
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "copyButton",
                                                on: {
                                                  click: function ($event) {
                                                    _vm.copyTextToClipboard(
                                                      _vm.maskContactInfo(
                                                        "email",
                                                        _vm.selectedHistory
                                                          .conversation.email
                                                      ) || "N/A"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("a-icon", {
                                                  attrs: { type: "copy" },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.getCustomLoginInfos(),
                                      function (inputValue) {
                                        return Array.isArray(
                                          _vm.selectedHistory.conversation
                                            .customLoginInfos
                                        ) &&
                                          _vm.selectedHistory.conversation
                                            .customLoginInfos.length
                                          ? _c(
                                              "div",
                                              {
                                                key: inputValue.name,
                                                staticClass: "user-detail",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "tippy",
                                                        rawName: "v-tippy",
                                                        value: {
                                                          followCursor: true,
                                                          placement:
                                                            "bottom-end",
                                                        },
                                                        expression:
                                                          "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                    }",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "icon material-icons",
                                                    attrs: {
                                                      content: inputValue.name,
                                                    },
                                                  },
                                                  [_vm._v("alternate_email")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "input-value",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "w-full" },
                                                      [
                                                        _vm._v(
                                                          "\n                                        " +
                                                            _vm._s(
                                                              inputValue.value ||
                                                                "N/A"
                                                            ) +
                                                            "\n                                    "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("div", [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "copyButton",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.copyTextToClipboard(
                                                                inputValue.value ||
                                                                  "N/A"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("a-icon", {
                                                            attrs: {
                                                              type: "copy",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e()
                                      }
                                    ),
                                    _vm._v(" "),
                                    _vm._l(
                                      (
                                        (_vm.selectedHistory.conversation
                                          .visitor &&
                                          _vm.selectedHistory.conversation
                                            .visitor.contactProperties) ||
                                        []
                                      ).filter(function (x) {
                                        return x.property
                                      }),
                                      function (attr) {
                                        return _vm.selectedHistory.conversation
                                          .visitor
                                          ? _c(
                                              "div",
                                              {
                                                key: attr._id,
                                                staticClass: "user-detail",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "tippy",
                                                        rawName: "v-tippy",
                                                        value: {
                                                          followCursor: true,
                                                          placement:
                                                            "bottom-end",
                                                        },
                                                        expression:
                                                          "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                    }",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "icon material-icons",
                                                    attrs: {
                                                      content:
                                                        attr.property.label,
                                                    },
                                                  },
                                                  [_vm._v("data_object")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "font-weight": "bold",
                                                      "font-size": "14px",
                                                      width: "100px",
                                                    },
                                                    attrs: {
                                                      content:
                                                        attr.property.label,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        attr.property.label
                                                      ) + ":"
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "input-value",
                                                  },
                                                  [
                                                    attr.property.type ===
                                                    "json"
                                                      ? _c(
                                                          "div",
                                                          [
                                                            _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "classic-button visitor-attr",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.JSONModal = true
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                            JSON PREVIEW\n                                        "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _vm.JSONModal
                                                              ? _c(
                                                                  "Modal2",
                                                                  {
                                                                    attrs: {
                                                                      title:
                                                                        attr
                                                                          .property
                                                                          .label,
                                                                      "show-footer": false,
                                                                    },
                                                                    on: {
                                                                      cancel:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.JSONModal = false
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "prism-editor",
                                                                      {
                                                                        staticClass:
                                                                          "my-editor",
                                                                        attrs: {
                                                                          value:
                                                                            _vm.jsonFormat(
                                                                              attr.value ||
                                                                                "N/A"
                                                                            ),
                                                                          "line-numbers": false,
                                                                          highlight:
                                                                            _vm.highlighter,
                                                                          readonly:
                                                                            "",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            display:
                                                                              "flex",
                                                                            "justify-content":
                                                                              "space-between",
                                                                          },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "SupsisButton",
                                                                          {
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.copyTextToClipboard(
                                                                                    attr.value ||
                                                                                      "N/A"
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                    COPY JSON\n                                                "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "SupsisButton",
                                                                          {
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  _vm.JSONModal = false
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " CANCEL"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      : _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "w-full",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                        " +
                                                                _vm._s(
                                                                  attr.value ||
                                                                    "N/A"
                                                                ) +
                                                                "\n                                    "
                                                            ),
                                                          ]
                                                        ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex centered",
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "copyButton",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.copyTextToClipboard(
                                                              attr.value ||
                                                                "N/A"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("a-icon", {
                                                          attrs: {
                                                            type: "copy",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e()
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]),
                              _vm._v(" "),
                              (
                                _vm.selectedHistory.conversation.visitor
                                  .metaReferrals || []
                              ).length > 0
                                ? _c("VisitorMetaReferralsCard", {
                                    attrs: {
                                      metaReferrals:
                                        _vm.selectedHistory.conversation.visitor
                                          .metaReferrals,
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("VisitorCalendarCard", {
                                attrs: {
                                  visitorId:
                                    _vm.selectedHistory.conversation.visitor
                                      ._id,
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { attrs: { id: "chatCard" } }, [
                                _c("div", { staticClass: "headtitle" }, [
                                  _c("span", { staticClass: "text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "userInfoWidget.affiliatedRepresentatives"
                                        )
                                      ) + " "
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  _vm._l(
                                    _vm.selectedHistory.conversation.users
                                      .length > 0
                                      ? _vm.selectedHistory.conversation.users.slice(
                                          0,
                                          3
                                        )
                                      : [
                                          _vm.selectedHistory.conversation
                                            .connectedUser,
                                        ],
                                    function (user, i) {
                                      return _c(
                                        "a-tag",
                                        { key: i, attrs: { color: "orange" } },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(_vm.getUserHelper(user)) +
                                              "\n                            "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { attrs: { id: "chatCard" } },
                                [
                                  _c("div", { staticClass: "headtitle" }, [
                                    _c("span", { staticClass: "text" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "userInfoWidget.preferredAgents"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _vm.selectedHistory.conversation.visitor
                                    ? _c("PreferredAgents", {
                                        attrs: {
                                          visitorId:
                                            _vm.selectedHistory.conversation
                                              .visitor._id,
                                        },
                                        model: {
                                          value:
                                            _vm.selectedHistory.conversation
                                              .visitor.preferredAgents,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.selectedHistory.conversation
                                                .visitor,
                                              "preferredAgents",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "selectedHistory.conversation.visitor.preferredAgents",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { attrs: { id: "chatCard" } }, [
                                _c("div", { staticClass: "headtitle" }, [
                                  _c("span", { staticClass: "text" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("userInfoWidget.labels"))
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  [
                                    _c("TagDialog", {
                                      model: {
                                        value: _vm.cloneTags,
                                        callback: function ($$v) {
                                          _vm.cloneTags = $$v
                                        },
                                        expression: "cloneTags",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { attrs: { id: "chatCard" } }, [
                                _c("div", { staticClass: "headtitle" }, [
                                  _c("span", { staticClass: "text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("userInfoWidget.agentNotes")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "ml-4" }, [
                                    !_vm.isNewNot
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "classic-button",
                                            on: {
                                              click: function ($event) {
                                                _vm.isNewNot = true
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "userInfoWidget.newNote"
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm.isNewNot ||
                                !_vm.infoObj ||
                                !_vm.infoObj.noteSender
                                  ? _c(
                                      "div",
                                      { staticClass: "rep-note-element mt-2" },
                                      [
                                        _c("a-textarea", {
                                          staticClass: "disableShortcut",
                                          model: {
                                            value: _vm.infoObj.info,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.infoObj, "info", $$v)
                                            },
                                            expression: "infoObj.info",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "rep-note-actions mt-1",
                                          },
                                          [
                                            _c(
                                              "a-button-group",
                                              { attrs: { size: "small" } },
                                              [
                                                _vm.infoObj &&
                                                _vm.infoObj.noteSender
                                                  ? _c("a-button", {
                                                      staticClass:
                                                        "classic-button mr-1",
                                                      attrs: {
                                                        icon: "close",
                                                        type: "danger",
                                                      },
                                                      on: {
                                                        click: _vm.notSaveInfo,
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("a-button", {
                                                  staticClass: "classic-button",
                                                  staticStyle: {
                                                    color: "rgb(38, 233, 38)",
                                                  },
                                                  attrs: {
                                                    icon: "check",
                                                    type: "primary",
                                                  },
                                                  on: { click: _vm.saveInfo },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.infoObj && _vm.infoObj.noteSender
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "old-note",
                                        on: {
                                          click: function ($event) {
                                            _vm.oldNoteIsOpen =
                                              !_vm.oldNoteIsOpen
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "classic-button open-note",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "material-icons icon",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.oldNoteIsOpen
                                                      ? "remove"
                                                      : "add"
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "information" },
                                          [
                                            _c("b", [_vm._v("1")]),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "userInfoWidget.available"
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.oldNoteIsOpen &&
                                _vm.infoObj &&
                                _vm.infoObj.noteSender
                                  ? _c(
                                      "div",
                                      { staticClass: "old-note-desc" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "top-header" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "agent-name" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.infoObj.noteSender)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "agent-note" },
                                          [_vm._v(_vm._s(_vm.infoObj.info))]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("div", { attrs: { id: "chatCard" } }, [
                                _c("div", { staticClass: "headtitle" }, [
                                  _c("span", { staticClass: "text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "userInfoWidget.systemInformation"
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "details-chat-card" },
                                  [
                                    _c("div", { staticClass: "user-detail" }, [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                followCursor: true,
                                                placement: "bottom-end",
                                              },
                                              expression:
                                                "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                    }",
                                            },
                                          ],
                                          staticClass: "icon material-icons",
                                          attrs: {
                                            content: _vm.$t(
                                              "userInfoWidget.speechID"
                                            ),
                                          },
                                        },
                                        [_vm._v("badge")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.selectedHistory.conversation._id
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "user-detail" }, [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                followCursor: true,
                                                placement: "bottom-end",
                                              },
                                              expression:
                                                "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                    }",
                                            },
                                          ],
                                          staticClass: "icon material-icons",
                                          attrs: {
                                            content: _vm.$t(
                                              "userInfoWidget.customerVersion"
                                            ),
                                          },
                                        },
                                        [_vm._v("info")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              (
                                                _vm.selectedHistory.conversation
                                                  .visitor.version || {
                                                  version: -1,
                                                  versionStr: "N/A",
                                                  buildNumber: -1,
                                                  commitHash: "",
                                                }
                                              ).versionStr
                                            ) +
                                            "\n                                "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _vm.selectedHistory.conversation.ref !==
                                    "whatsapp"
                                      ? _c(
                                          "div",
                                          { staticClass: "user-detail" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "tippy",
                                                    rawName: "v-tippy",
                                                    value: {
                                                      followCursor: true,
                                                      placement: "bottom-end",
                                                    },
                                                    expression:
                                                      "{ followCursor: true, placement: 'bottom-end' }",
                                                  },
                                                ],
                                                staticClass:
                                                  "icon material-icons",
                                                attrs: {
                                                  content: _vm.$t(
                                                    "userInfoWidget.IPAddress"
                                                  ),
                                                },
                                              },
                                              [_vm._v("computer")]
                                            ),
                                            _vm._v(" "),
                                            !(
                                              !!_vm.selectedHistory.conversation
                                                .whatsappNumber ||
                                              !!_vm.selectedHistory.conversation
                                                .instagramUserId
                                            )
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        _vm.selectedHistory
                                                          .conversation
                                                          .ipAddress
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.selectedHistory.conversation
                                              .ref === "instagram"
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      width: "30px",
                                                      height: "30px",
                                                    },
                                                  },
                                                  [
                                                    _c("InstagramIcon", {
                                                      attrs: {
                                                        width: 30,
                                                        height: 30,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.selectedHistory.conversation.ref ===
                                    "whatsapp"
                                      ? _c(
                                          "div",
                                          { staticClass: "user-detail" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "tippy",
                                                    rawName: "v-tippy",
                                                    value: {
                                                      followCursor: true,
                                                      placement: "bottom-end",
                                                    },
                                                    expression:
                                                      "{ followCursor: true, placement: 'bottom-end' }",
                                                  },
                                                ],
                                                attrs: { content: "Whatsapp" },
                                              },
                                              [
                                                _c(
                                                  "md-icon",
                                                  {
                                                    staticStyle: {
                                                      color: "#06e576",
                                                      "font-size": "11px",
                                                    },
                                                  },
                                                  [_vm._v(" whatsapp ")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  "margin-left": "7px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.selectedHistory
                                                      .conversation
                                                      .whatsappNumber
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.getChannelName()
                                      ? _c(
                                          "div",
                                          { staticClass: "user-detail" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "tippy",
                                                    rawName: "v-tippy",
                                                    value: {
                                                      followCursor: true,
                                                      placement: "bottom-end",
                                                    },
                                                    expression:
                                                      "{ followCursor: true, placement: 'bottom-end' }",
                                                  },
                                                ],
                                                staticClass:
                                                  "icon material-icons",
                                                attrs: {
                                                  content: _vm.$t(
                                                    "whatsappChannel.channelName"
                                                  ),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "hub\n                                "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(_vm.getChannelName()) +
                                                  "\n                                "
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.selectedHistory.conversation.ref !==
                                    "whatsapp"
                                      ? _c(
                                          "div",
                                          { staticClass: "user-detail" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "tippy",
                                                    rawName: "v-tippy",
                                                    value: {
                                                      followCursor: true,
                                                      placement: "bottom-end",
                                                    },
                                                    expression:
                                                      "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                    }",
                                                  },
                                                ],
                                                staticClass:
                                                  "icon material-icons",
                                                attrs: {
                                                  content: _vm.$t(
                                                    "userInfoWidget.pageVisited"
                                                  ),
                                                },
                                              },
                                              [_vm._v("public")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "white-space": "nowrap",
                                                  overflow: "hidden",
                                                  "text-overflow": "ellipsis",
                                                },
                                              },
                                              [
                                                _vm.selectedHistory.conversation
                                                  .visitingPage
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "info-label",
                                                        attrs: {
                                                          href: _vm
                                                            .selectedHistory
                                                            .conversation
                                                            .visitingPage
                                                            ? _vm
                                                                .selectedHistory
                                                                .conversation
                                                                .visitingPage
                                                            : "#",
                                                          target: "_blank",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.selectedHistory
                                                              .conversation
                                                              .visitingPage
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _c("span", [_vm._v("N/A")]),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "user-detail" }, [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: {
                                                followCursor: true,
                                                placement: "bottom-end",
                                              },
                                              expression:
                                                "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                    }",
                                            },
                                          ],
                                          staticClass: "icon material-icons",
                                          attrs: {
                                            content: _vm.$t(
                                              "userInfoWidget.countryAndLanguage"
                                            ),
                                          },
                                        },
                                        [_vm._v("map")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "d-flex",
                                          staticStyle: {
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _vm.getCountryCode(
                                            _vm.$_.get(
                                              _vm.selectedHistory,
                                              "conversation.geoLocation.country"
                                            ) ||
                                              _vm.selectedHistory.conversation
                                                .languageCode
                                          )
                                            ? _c("country-flag", {
                                                directives: [
                                                  {
                                                    name: "tippy",
                                                    rawName: "v-tippy",
                                                    value: {
                                                      followCursor: true,
                                                      placement: "bottom-end",
                                                      theme: _vm.isDarkMode
                                                        ? "light-border"
                                                        : "google",
                                                    },
                                                    expression:
                                                      "{\n                                            followCursor: true,\n                                            placement: 'bottom-end',\n                                            theme: isDarkMode ? 'light-border' : 'google',\n                                        }",
                                                  },
                                                ],
                                                staticStyle: {
                                                  "margin-top": "-8px",
                                                },
                                                attrs: {
                                                  content: _vm.getCountryName(
                                                    _vm.$_.get(
                                                      _vm.selectedHistory,
                                                      "conversation.geoLocation.country"
                                                    ) ||
                                                      _vm.selectedHistory
                                                        .conversation
                                                        .languageCode
                                                  ),
                                                  country: _vm.getCountryCode(
                                                    _vm.$_.get(
                                                      _vm.selectedHistory,
                                                      "conversation.geoLocation.country"
                                                    ) ||
                                                      _vm.selectedHistory
                                                        .conversation
                                                        .languageCode
                                                  ),
                                                  size: "normal",
                                                },
                                              })
                                            : _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "tippy",
                                                      rawName: "v-tippy",
                                                      value: {
                                                        followCursor: true,
                                                        placement: "bottom-end",
                                                        theme: _vm.isDarkMode
                                                          ? "light-border"
                                                          : "google",
                                                      },
                                                      expression:
                                                        "{\n                                            followCursor: true,\n                                            placement: 'bottom-end',\n                                            theme: isDarkMode ? 'light-border' : 'google',\n                                        }",
                                                    },
                                                  ],
                                                  attrs: {
                                                    content: _vm.getCountryName(
                                                      _vm.$_.get(
                                                        _vm.selectedHistory,
                                                        "conversation.geoLocation.country"
                                                      ) ||
                                                        _vm.selectedHistory
                                                          .conversation
                                                          .languageCode
                                                    ),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.selectedHistory
                                                          .conversation
                                                          .geoLocation
                                                          ? _vm.selectedHistory
                                                              .conversation
                                                              .geoLocation
                                                              .country
                                                          : "N/A"
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "margin-left": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$_.get(
                                                      _vm.selectedHistory
                                                        .conversation,
                                                      "languageCode",
                                                      ""
                                                    ).toUpperCase()
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "user-detail" }, [
                                      !(
                                        _vm.selectedHistory.conversation
                                          .whatsappNumber ||
                                        _vm.selectedHistory.conversation
                                          .instagramUserId
                                      )
                                        ? _c(
                                            "span",
                                            [
                                              _vm.selectedHistory.conversation
                                                .visitor.os &&
                                              _vm.selectedHistory.conversation
                                                .visitor.browser
                                                ? _c("VisitorBrowserAndOs", {
                                                    attrs: {
                                                      visitor:
                                                        _vm.selectedHistory
                                                          .conversation.visitor,
                                                    },
                                                  })
                                                : _c("p", [
                                                    _vm._v(
                                                      "\n                                        " +
                                                        _vm._s(
                                                          _vm.getUserDetailedLoginInfo(
                                                            _vm.selectedHistory
                                                              .conversation
                                                              .userAgent
                                                          )
                                                        ) +
                                                        "\n                                    "
                                                    ),
                                                  ]),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.site._id === "5d14ee322d95ad001ebdf213"
                                ? _c("div", { attrs: { id: "chatCard" } }, [
                                    _c("div", { staticClass: "headtitle" }, [
                                      _c("span", { staticClass: "text" }, [
                                        _vm._v("Flowlu Aktar"),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      [
                                        _c(
                                          "SupsisButton2",
                                          {
                                            attrs: { primary: "" },
                                            on: { click: _vm.flowluTransfer },
                                          },
                                          [_vm._v("Chati Aktar")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "text-center information-list2",
                              staticStyle: { padding: "unset" },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("message.noMessageInChat")) +
                                  "\n                "
                              ),
                            ]
                          ),
                    ]
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isModalShow
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "visitor-message",
                title: _vm.$t("message.visitorFeedback"),
                "show-footer": false,
              },
              on: { cancel: _vm.hideModal },
            },
            [
              _c(
                "p",
                {
                  staticClass: "my-4",
                  staticStyle: { "word-wrap": "break-word" },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.selectedHistory.conversation.description) +
                      "\n        "
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }